const CONFIGURATION_PRICE_SERVICE_PATH = 'apps/bc/prices/configuration';

class PSTConfigurablePriceService {

  async getConfigurationPrice(data) {
    const priceResult = await fetch(
      `/${CONFIGURATION_PRICE_SERVICE_PATH}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    );
    if (!priceResult.ok) {
      console.debug(`Error fetching price result: [${priceResult.status}] ${priceResult.statusText}`);
      return;
    }
    const result = await priceResult.json();
    return result.items
  }
}

window.PSTConfigurablePriceService = new PSTConfigurablePriceService()